import { Col, Form, Row, Select } from "antd"
import { QboAccountFieldErrors } from "../../../domain/invoicing/settings/invoicingSettings"
import { useQboAccountsQuery } from "../../../domain/quickbooks/quickbooksQueries"
import { getDepositAccountOptions, getFeesExpenseAccountOptions } from "./invoicingSettingsModel"
import SettingsTitledCard from "../SettingsTitledCard"

type Props = {
  qboDepositBankAccountId: string | null
  qboFeesExpenseAccountId: string | null
  fieldErrors: QboAccountFieldErrors
  onChange: (updates: Partial<{ qboDepositBankAccountId: string, qboFeesExpenseAccountId: string }>) => void
}

const QboAccountsCard = ({ qboDepositBankAccountId, qboFeesExpenseAccountId, fieldErrors, onChange }: Props) => {
  const accountsQuery = useQboAccountsQuery()
  const depositOptions = getDepositAccountOptions(accountsQuery.data ?? [])
  const feesOptions = getFeesExpenseAccountOptions(accountsQuery.data ?? [])

  return <SettingsTitledCard
    title="QuickBooks Accounts"
    description="Choose which QuickBooks accounts will record SynkedUP Payments payouts."
  >
    <Form layout="vertical" component="div">
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Deposit Account"
            required
            validateStatus={fieldErrors.qboDepositBankAccountId ? 'error' : undefined}
            help={fieldErrors.qboDepositBankAccountId}
            style={{ marginBottom: 0 }}
          >
            <Select
              value={qboDepositBankAccountId ?? undefined}
              placeholder="Select an account"
              loading={accountsQuery.isLoading}
              options={depositOptions}
              onChange={v => onChange({ qboDepositBankAccountId: v })}
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Processor Fees Account"
            required
            validateStatus={fieldErrors.qboFeesExpenseAccountId ? 'error' : undefined}
            help={fieldErrors.qboFeesExpenseAccountId}
            style={{ marginBottom: 0 }}
          >
            <Select
              value={qboFeesExpenseAccountId ?? undefined}
              placeholder="Select an account"
              loading={accountsQuery.isLoading}
              options={feesOptions}
              onChange={v => onChange({ qboFeesExpenseAccountId: v })}
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  </SettingsTitledCard>
}

export default QboAccountsCard
